<p-checkbox
  [formControl]="ngControl.control | abstractControlToFormControl"
  [binary]="binary()"
  [inputId]="inputId()"
  (onChange)="checkedChange.emit($event.checked)" />
<label [for]="inputId()">{{ label() }}</label>
